/* Bubble de promoção cruzada: atualiza após mutações do carrinho e
   respeita a dispensa durante a sessão atual do navegador. */
(function () {
  const ROOT_ID = 'magon-promo-bubble-root';
  const STORAGE_PREFIX = 'magon:promo-dismissed:';
  const memoryDismissals = new Set();
  let refreshTimer;
  let activeRequest;

  function storageKey(promoKey) {
    return `${STORAGE_PREFIX}${promoKey}`;
  }

  function isDismissed(promoKey) {
    if (!promoKey) return true;
    if (memoryDismissals.has(promoKey)) return true;
    try {
      return sessionStorage.getItem(storageKey(promoKey)) === '1';
    } catch {
      return false;
    }
  }

  function dismiss(promoKey) {
    if (!promoKey) return;
    memoryDismissals.add(promoKey);
    try {
      sessionStorage.setItem(storageKey(promoKey), '1');
    } catch {}
  }

  function revealCurrentBubble() {
    const bubble = document.querySelector('[data-magon-promo-bubble]');
    if (!bubble || isDismissed(bubble.dataset.promoKey)) return;
    bubble.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => bubble.classList.add('is-visible')));
  }

  async function refreshBubble() {
    const currentRoot = document.getElementById(ROOT_ID);
    if (!currentRoot) return;

    activeRequest?.abort();
    activeRequest = new AbortController();

    try {
      const shopRoot = window.Shopify?.routes?.root || '/';
      const separator = shopRoot.includes('?') ? '&' : '?';
      const response = await fetch(`${shopRoot}${separator}section_id=magon-promo-bubble`, {
        headers: { Accept: 'text/html' },
        signal: activeRequest.signal,
        credentials: 'same-origin'
      });
      if (!response.ok) return;

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const nextRoot = doc.getElementById(ROOT_ID);
      if (!nextRoot) return;

      currentRoot.replaceChildren(...Array.from(nextRoot.childNodes).map(node => node.cloneNode(true)));
      revealCurrentBubble();
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('Magon promo bubble:', error);
    }
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshBubble, 120);
  }

  document.addEventListener('click', event => {
    const closeButton = event.target.closest('[data-magon-promo-close]');
    if (!closeButton) return;

    const bubble = closeButton.closest('[data-magon-promo-bubble]');
    if (!bubble) return;
    dismiss(bubble.dataset.promoKey);
    bubble.classList.remove('is-visible');
    window.setTimeout(() => { bubble.hidden = true; }, 280);
  });

  document.addEventListener('cart:update', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealCurrentBubble, { once: true });
  } else {
    revealCurrentBubble();
  }
})();
